export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9000.5867f55a.jpg";